import { render, staticRenderFns } from "./Shortener.vue?vue&type=template&id=71b1d5bf&scoped=true&"
import script from "./Shortener.vue?vue&type=script&lang=js&"
export * from "./Shortener.vue?vue&type=script&lang=js&"
import style0 from "./Shortener.vue?vue&type=style&index=0&id=71b1d5bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1d5bf",
  null
  
)

export default component.exports